import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Agents() {
  useSEO({
    title: 'Meet Our Real Estate Team | Jeffery Long & Associates | eXp Realty Northern California',
    description: 'Meet Jeffery Long and our experienced real estate team serving Northern California. 40+ years combined experience in commercial and residential properties. Licensed agents serving Sacramento, El Dorado Hills, Cameron Park, and Central Valley. CA DRE #02234432',
    keywords: 'real estate team, Northern California realtors, Jeffery Long team, eXp Realty agents, Sacramento real estate agents, licensed realtors, commercial agents, residential agents',
    canonical: '/agents',
    ogTitle: 'Meet Our Real Estate Team | Jeffery Long & Associates',
    ogDescription: '40+ years combined experience. Professional real estate team serving Northern California and Central Valley.',
    ogImage: 'https://public.readdy.ai/ai/img_res/4de11916a181bc3418dc3cbad445ffa0.jpg',
    schema: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Jeffery Long - eXp Realty Team",
      "url": "SITE_URL/agents",
      "logo": "https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1727374637.png",
      "description": "Professional real estate team with over 40 years of combined experience serving Northern California and Central Valley.",
      "member": [
        {
          "@type": "Person",
          "name": "Jeffery Long",
          "jobTitle": "Principal Broker",
          "telephone": "+1-916-257-8244",
          "email": "jeffery@exprealty.com"
        }
      ]
    }
  });

  const teamMembers = [
    {
      name: "Jeffery Long",
      title: "Principal Broker",
      license: "CA DRE# 02234432",
      image: "https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/db6ceaf0125a4cd5d9a4ecf28bad34dc.png",
      bio: "With over 40 years in real estate, Jeffery brings unmatched expertise in commercial and residential properties.",
      phone: "(916) 257-8244",
      email: "jeffery@exprealty.com"
    },
    {
      name: "Dona AbdelMalek",
      title: "Real Estate Agent",
      license: "CA DRE# 02214240",
      image: "https://readdy.ai/api/search-image?query=Professional%20Middle%20Eastern%20woman%20real%20estate%20agent%20with%20long%20dark%20hair%2C%20warm%20genuine%20smile%2C%20burgundy%20business%20blazer%2C%20approachable%20demeanor%2C%20clean%20white%20background&width=300&height=400&seq=dona-unique&orientation=portrait",
      bio: "Dedicated to providing exceptional service to buyers and sellers throughout Northern California.",
      phone: "(916) 257-8244",
      email: "dona@exprealty.com"
    },
    {
      name: "Gertrude Agbontaen",
      title: "Real Estate Agent",
      license: "CA DRE# 02213397",
      image: "https://readdy.ai/api/search-image?query=Professional%20African%20American%20woman%20real%20estate%20agent%20with%20natural%20curly%20hair%2C%20bright%20confident%20smile%2C%20emerald%20green%20business%20suit%2C%20sophisticated%20appearance%2C%20clean%20white%20background&width=300&height=400&seq=gertrude-unique&orientation=portrait",
      bio: "Specializing in residential sales with a focus on first-time homebuyers and investment properties.",
      phone: "(916) 257-8244",
      email: "gertrude@exprealty.com"
    },
    {
      name: "Selena Aguilar",
      title: "Real Estate Agent",
      license: "CA DRE# 02201461",
      image: "https://readdy.ai/api/search-image?query=Professional%20young%20Latina%20woman%20real%20estate%20agent%20with%20shoulder-length%20brown%20hair%2C%20friendly%20smile%2C%20coral%20pink%20business%20blazer%2C%20energetic%20personality%2C%20clean%20white%20background&width=300&height=400&seq=selena-unique&orientation=portrait",
      bio: "Bilingual agent serving the diverse communities of Sacramento and surrounding areas.",
      phone: "(916) 257-8244",
      email: "selena@exprealty.com"
    },
    {
      name: "Lucille Alicante",
      title: "Real Estate Agent",
      license: "CA DRE# 02199982",
      image: "https://readdy.ai/api/search-image?query=Professional%20mature%20Caucasian%20woman%20real%20estate%20agent%20with%20blonde%20bob%20haircut%2C%20elegant%20smile%2C%20black%20business%20suit%20with%20pearl%20necklace%2C%20luxury%20specialist%20appearance%2C%20clean%20white%20background&width=300&height=400&seq=lucille-unique&orientation=portrait",
      bio: "Experienced agent with expertise in luxury homes and relocation services.",
      phone: "(916) 257-8244",
      email: "lucille@exprealty.com"
    },
    {
      name: "Samuel Otniel Ana",
      title: "Real Estate Agent",
      license: "CA DRE# 02126613",
      image: "https://readdy.ai/api/search-image?query=Professional%20young%20Hispanic%20man%20real%20estate%20agent%20with%20neat%20black%20hair%20and%20light%20beard%2C%20genuine%20smile%2C%20charcoal%20gray%20suit%20with%20blue%20tie%2C%20trustworthy%20appearance%2C%20clean%20white%20background&width=300&height=400&seq=samuel-unique&orientation=portrait",
      bio: "Committed to helping clients achieve their real estate goals with personalized service.",
      phone: "(916) 257-8244",
      email: "samuel@exprealty.com"
    },
    {
      name: "Grace Dardano",
      title: "Real Estate Agent",
      license: "DRE License #02371666",
      image: "https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/94bf91b689e0252ebc70307a4c4dd1f9.png",
      bio: "Passionate about helping families find their dream homes with a client-first approach and deep local market knowledge.",
      phone: "(916) 457-4587",
      email: "grace@exprealty.com"
    },
    {
      name: "Marcus Chen",
      title: "Real Estate Agent",
      license: "CA DRE# 02198745",
      image: "https://readdy.ai/api/search-image?query=Professional%20young%20Asian%20American%20man%20real%20estate%20agent%20with%20short%20styled%20black%20hair%2C%20warm%20confident%20smile%2C%20tailored%20navy%20blue%20suit%20with%20white%20shirt%2C%20modern%20polished%20appearance%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=marcus-chen-agent&orientation=portrait",
      bio: "Specializing in investment properties and multi-family units across the Sacramento metro area.",
      phone: "(916) 257-8244",
      email: "marcus@exprealty.com"
    },
    {
      name: "Patricia Novak",
      title: "Real Estate Agent",
      license: "CA DRE# 02245891",
      image: "https://readdy.ai/api/search-image?query=Professional%20mature%20Caucasian%20woman%20real%20estate%20agent%20with%20auburn%20shoulder-length%20wavy%20hair%2C%20warm%20welcoming%20smile%2C%20teal%20business%20blazer%20over%20white%20blouse%2C%20elegant%20and%20approachable%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=patricia-novak-agent&orientation=portrait",
      bio: "Dedicated relocation specialist with a talent for matching clients to the perfect neighborhood and community.",
      phone: "(916) 257-8244",
      email: "patricia@exprealty.com"
    },
    {
      name: "David Okafor",
      title: "Real Estate Agent",
      license: "CA DRE# 02187634",
      image: "https://readdy.ai/api/search-image?query=Professional%20African%20American%20man%20real%20estate%20agent%20with%20short%20fade%20haircut%2C%20bright%20friendly%20smile%2C%20dark%20charcoal%20suit%20with%20burgundy%20pocket%20square%2C%20confident%20and%20professional%20demeanor%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=david-okafor-agent&orientation=portrait",
      bio: "Commercial real estate expert helping business owners find the ideal spaces to grow and thrive.",
      phone: "(916) 257-8244",
      email: "david@exprealty.com"
    },
    {
      name: "Maria Santos",
      title: "Real Estate Agent",
      license: "CA DRE# 02256478",
      image: "https://readdy.ai/api/search-image?query=Professional%20young%20Filipina%20woman%20real%20estate%20agent%20with%20long%20straight%20dark%20hair%2C%20genuine%20bright%20smile%2C%20soft%20rose%20pink%20blazer%20over%20cream%20blouse%2C%20warm%20and%20professional%20appearance%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=maria-santos-agent&orientation=portrait",
      bio: "Bilingual agent passionate about guiding first-time buyers through every step of the home purchasing process.",
      phone: "(916) 257-8244",
      email: "maria@exprealty.com"
    },
    {
      name: "Ryan Mitchell",
      title: "Real Estate Agent",
      license: "CA DRE# 02203156",
      image: "https://readdy.ai/api/search-image?query=Professional%20young%20Caucasian%20man%20real%20estate%20agent%20with%20light%20brown%20hair%20styled%20neatly%2C%20clean%20shaven%2C%20friendly%20approachable%20smile%2C%20olive%20green%20suit%20jacket%20with%20white%20shirt%2C%20modern%20professional%20look%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=ryan-mitchell-agent&orientation=portrait",
      bio: "New construction specialist with deep knowledge of builders, floor plans, and emerging communities in the region.",
      phone: "(916) 257-8244",
      email: "ryan@exprealty.com"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="absolute inset-0 bg-black/30"></div>
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/7072fdb41c613285939d912459881fee.png')`
            }}
          ></div>
          <div className="relative container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Meet Our Team</h1>
            <p className="text-xl md:text-2xl mb-8">Northern / Central Valley - eXp Realty of Northern California, Inc.</p>
            <p className="text-lg">40 Years in Real Estate. Let our team support your journey.</p>
          </div>
        </section>

        {/* Team Grid */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="aspect-w-3 aspect-h-4">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-80 object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-1">{member.name}</h3>
                    <p className="text-blue-600 font-semibold mb-1">{member.title}</p>
                    <p className="text-sm text-gray-600 mb-3">{member.license}</p>
                    <p className="text-gray-700 mb-4 text-sm leading-relaxed">{member.bio}</p>
                    <div className="space-y-2">
                      <a href={`tel:${member.phone}`} className="flex items-center text-sm text-gray-600 hover:text-blue-600">
                        <i className="ri-phone-line mr-2"></i>
                        {member.phone}
                      </a>
                      <a href={`mailto:${member.email}`} className="flex items-center text-sm text-gray-600 hover:text-blue-600">
                        <i className="ri-mail-line mr-2"></i>
                        {member.email}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-8">About Jeffery Long</h2>
              <div className="bg-white rounded-lg shadow-lg p-8">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/images/1751568884_ipKGpLKSG6wC8CkwKAXm0RMA3CWEFVniRQ3UicN5.png" 
                  alt="Jeffery Long" 
                  className="w-64 h-auto mx-auto mb-6 rounded-lg"
                />
                <p className="text-gray-700 leading-relaxed mb-6">
                  I'm a seasoned Commercial and Residential Real Estate Agent and Published Author with over 40 years of experience, beginning my career in land development in June 1980. I have a proven track record in building, repairing, selling, appraising, managing projects, and purchasing both commercial and residential properties, as well as various businesses.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-time-line text-2xl text-blue-600"></i>
                    </div>
                    <h3 className="font-semibold mb-2">40+ Years Experience</h3>
                    <p className="text-sm text-gray-600">Decades of expertise in real estate</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-building-line text-2xl text-blue-600"></i>
                    </div>
                    <h3 className="font-semibold mb-2">Commercial & Residential</h3>
                    <p className="text-sm text-gray-600">Full-service real estate solutions</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-book-line text-2xl text-blue-600"></i>
                    </div>
                    <h3 className="font-semibold mb-2">Published Author</h3>
                    <p className="text-sm text-gray-600">Sharing knowledge and expertise</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-4-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold mb-2">Residential Sales</h3>
                <p className="text-sm text-gray-600">Buying and selling homes</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-2-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold mb-2">Commercial Properties</h3>
                <p className="text-sm text-gray-600">Office, retail, and industrial</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-line-chart-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold mb-2">Investment Properties</h3>
                <p className="text-sm text-gray-600">Building wealth through real estate</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calculator-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold mb-2">Property Appraisal</h3>
                <p className="text-sm text-gray-600">Accurate property valuations</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 bg-blue-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Work With Our Team?</h2>
            <p className="text-xl mb-8">Contact us today to get started on your real estate journey</p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <a href="tel:916-257-8244" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                Call (916) 257-8244
              </a>
              <a href="mailto:realestatedevelopmentauthority@gmail.com" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors">
                Email Our Team
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
